import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const User = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/user">
        <g id="user">
          <path
            id="Vector"
            d="M8.0013 8.50004C5.88797 8.50004 4.16797 6.78004 4.16797 4.66671C4.16797 2.55337 5.88797 0.833374 8.0013 0.833374C10.1146 0.833374 11.8346 2.55337 11.8346 4.66671C11.8346 6.78004 10.1146 8.50004 8.0013 8.50004ZM8.0013 1.83337C6.4413 1.83337 5.16797 3.10671 5.16797 4.66671C5.16797 6.22671 6.4413 7.50004 8.0013 7.50004C9.5613 7.50004 10.8346 6.22671 10.8346 4.66671C10.8346 3.10671 9.5613 1.83337 8.0013 1.83337Z"
          />
          <path
            id="Vector_2"
            d="M13.7268 15.1667C13.4534 15.1667 13.2268 14.94 13.2268 14.6667C13.2268 12.3667 10.8801 10.5 8.0001 10.5C5.1201 10.5 2.77344 12.3667 2.77344 14.6667C2.77344 14.94 2.54677 15.1667 2.27344 15.1667C2.0001 15.1667 1.77344 14.94 1.77344 14.6667C1.77344 11.82 4.56677 9.5 8.0001 9.5C11.4334 9.5 14.2268 11.82 14.2268 14.6667C14.2268 14.94 14.0001 15.1667 13.7268 15.1667Z"
          />
        </g>
      </g>
    </svg>
  );
};

User.displayName = 'User';
